// Microsoft Clarity — sessie-opnames en heatmaps.
// Laadt alleen na expliciete analytische toestemming (zie CookieBanner),
// conform hetzelfde consent-model als Google Analytics.

const CLARITY_ID = "ypxn3pnrl0";
const CLARITY_SRC = `https://www.clarity.ms/tag/${CLARITY_ID}`;

type ClarityFn = ((...args: unknown[]) => void) & { q?: unknown[] };

declare global {
  interface Window {
    clarity?: ClarityFn;
  }
}

export const loadClarity = () => {
  if (typeof window === "undefined") return;
  const w = window as Window & { clarity?: ClarityFn };

  // Standaard Clarity-snippet: queue aanleggen vóór het script laadt.
  if (!w.clarity) {
    w.clarity = function (...args: unknown[]) {
      const fn = w.clarity as ClarityFn;
      fn.q = fn.q || [];
      fn.q.push(args);
    };
  }

  if (document.querySelector(`script[src="${CLARITY_SRC}"]`)) return;
  const script = document.createElement("script");
  script.async = true;
  script.src = CLARITY_SRC;
  document.head.appendChild(script);
};
